/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const UNDERLINE_START = new (class UStart {})();
export const UNDERLINE_END = new (class UEnd {})();

@Injectable()
export class UnderlineTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<u>',
                token: UNDERLINE_START,
            },
            end: {
                search: '</u>',
                token: UNDERLINE_END,
            },
            elementTag: 'u',
        });
    }
}
